const pad2 = (n) => String(n).padStart(2, '0');

export const localDateStr = (d) => `${d.getFullYear()}-${pad2(d.getMonth() + 1)}-${pad2(d.getDate())}`;

export const getCampaignStatus = (campaign, todayStr) => {
	if (parseInt(campaign.publish_status) !== 1) {
		return 'draft';
	}
	const today = todayStr || localDateStr(new Date());
	if (campaign.start_date && today < campaign.start_date) {
		return 'upcoming';
	}
	if (campaign.end_date && today > campaign.end_date) {
		return 'expired';
	}
	return 'active';
};

export const monthOverlaps = (startDate, endDate, ym) => {
	if (!ym || ym === 'all') {
		return true;
	}
	if (!startDate || !endDate) {
		return false;
	}
	const [y, m] = ym.split('-').map(Number);
	const lastDay = new Date(y, m, 0).getDate();
	const monthStart = `${ym}-01`;
	const monthEnd = `${ym}-${String(lastDay).padStart(2, '0')}`;
	return startDate <= monthEnd && endDate >= monthStart;
};

const MONTH_LABELS = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];

export const buildMonthOptions = (now = new Date()) => {
	const options = [];
	for (let offset = -12; offset <= 12; offset++) {
		const d = new Date(now.getFullYear(), now.getMonth() + offset, 1);
		const value = `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, '0')}`;
		options.push({ value, label: `${MONTH_LABELS[d.getMonth()]} ${d.getFullYear()}` });
	}
	return options;
};

export const validatePublish = (form, language) => {
	const errors = [];
	if (!form.name || !form.name.trim()) {
		errors.push({ section: 1, field: 'name', message: language.err_name_required });
	}
	if (!(parseInt(form.brand_id) > 0)) {
		errors.push({ section: 1, field: 'brand_id', message: language.err_brand_required });
	}
	if (!form.start_date || !form.end_date) {
		errors.push({ section: 1, field: 'start_date', message: language.err_dates_required });
	} else if (form.start_date > form.end_date) {
		errors.push({ section: 1, field: 'start_date', message: language.err_date_order });
	}
	if (form.skus.length === 0) {
		errors.push({ section: 2, message: language.err_min_one_sku });
	} else if (form.skus.some((s) => s.promo_price === '' || s.promo_price === null || s.promo_price === undefined)) {
		errors.push({ section: 2, message: language.err_promo_price_required });
	}
	if (form.outlets.length === 0) {
		errors.push({ section: 3, message: language.err_min_one_outlet });
	}
	if (form.tasks.length === 0) {
		errors.push({ section: 4, message: language.err_min_one_task });
	} else {
		if (form.tasks.some((t) => !t.description || !t.description.trim())) {
			errors.push({ section: 4, message: language.err_task_desc_required });
		}
		if (form.tasks.some((t) => t.applies_to === 'specific' && (!t.task_skus || t.task_skus.length === 0))) {
			errors.push({ section: 4, message: language.err_task_skus_required });
		}
	}
	if (!form.task_start_date || !form.task_due_date) {
		errors.push({ section: 4, field: 'task_start_date', message: language.err_task_dates_required });
	} else {
		if (form.task_start_date > form.task_due_date) {
			errors.push({ section: 4, field: 'task_start_date', message: language.err_task_date_order });
		}
		if (form.start_date && form.task_due_date >= form.start_date) {
			errors.push({ section: 4, field: 'task_due_date', message: language.err_task_due_before_start });
		}
	}
	return errors;
};

export const fileToDownscaledBase64 = (file, maxDim = 1280, quality = 0.85) => new Promise((resolve, reject) => {
	const reader = new FileReader();
	reader.onload = (e) => {
		const img = new Image();
		img.onload = () => {
			const scale = Math.min(1, maxDim / Math.max(img.width, img.height));
			const canvas = document.createElement('canvas');
			canvas.width = Math.round(img.width * scale);
			canvas.height = Math.round(img.height * scale);
			canvas.getContext('2d').drawImage(img, 0, 0, canvas.width, canvas.height);
			resolve(canvas.toDataURL('image/jpeg', quality));
		};
		img.onerror = reject;
		img.src = e.target.result;
	};
	reader.onerror = reject;
	reader.readAsDataURL(file);
});
